import { render, staticRenderFns } from "./SoftwareFormEditor.vue?vue&type=template&id=e6126d60"
import script from "./SoftwareFormEditor.vue?vue&type=script&lang=js"
export * from "./SoftwareFormEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports